<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="user-box">
    <s-header :name="'赚积分'"></s-header>
    <van-skeleton title :avatar="true" :row="4" :loading="loading">
      <div class="user-info">
        <div class="info">
          <img src="https://s.yezgea02.com/1604040746310/aaaddd.png"/>
          <div class="user-desc">
            <span>姓名：{{ user.nickName }}</span>
            <span>登录名：{{ user.loginName }}</span>
            <span>积分：{{ user.point }}</span>
            <span class="name">网格：{{ user.area }}</span>
          </div>
        </div>
      </div>
    </van-skeleton>

    <van-divider >赚积分</van-divider>

    <van-skeleton title :row="3" :loading="loading">
      <van-grid :column-num="3" clickable>
        <van-grid-item v-for="value in gridValue" :key="value.name" :text="value.name"
                       :to="{ path: value.path, query: value.params}"/>
      </van-grid>

    </van-skeleton>
    <ul class="user-list">
      <h2>上报</h2>
<!--      <van-divider content-position="left">上报</van-divider>-->

      <li class="van-hairline--bottom" @click="goTo('/task-add')">
        <span> 任务上报 </span>
        <van-icon name="arrow"/>
      </li>

      <li class="van-hairline--bottom" @click="goTo('/my-task')">
        <span> 我的上报 </span>
        <van-icon name="arrow"/>
      </li>
<!--      <van-divider />-->
<!--      <van-divider content-position="left">发布</van-divider>-->

      <h2>发布</h2>
      <li class="van-hairline--bottom" @click="goTo('/task-publish')">
        <span> 任务发布 </span>
        <van-icon name="arrow"/>
      </li>
      <li class="van-hairline--bottom" @click="goTo('/my-publish', { from: 'mine' })">
        <span> 我的发布 </span>
        <van-icon name="arrow"/>
      </li>
<!--      <van-divider />-->
<!--      <van-divider content-position="left">领取</van-divider>-->
      <h2>领取</h2>
      <li @click="goTo('/my-pick')">
        <span> 领取任务 </span>
        <van-icon name="arrow"/>
      </li>
      <li @click="goTo('/my-assign')">
        <span> 我的领取 </span>
        <van-icon name="arrow"/>
      </li>
    </ul>
    <nav-bar></nav-bar>
  </div>
</template>

<script>
import {onMounted, reactive, toRefs} from 'vue'
import navBar from '@/components/NavBar'
import sHeader from '@/components/SimpleHeader'
import {getUserInfo} from '@/service/user'
import {useRouter} from 'vue-router'

export default {
  components: {
    navBar,
    sHeader
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      user: {},
      loading: true,
      gridValue: [
        {
          name: "积分规则",
          path: '/infoList',
          params: {name: "rule", tag: 0}
        },
        {
          name: "文章学习",
          path: '/learn'
        }, {
          name: "自主申报",
          path: '/task-add',
          params: {name: "publicize", tag: 0}
        }, {
          name: "活动参与",
          path: '/my-pick',
          params: {name: "rank", tag: 0}
        }, {
          name: "发布任务",
          path: '/task-publish',
          params: {name: "party", tag: 0}
        }, {
          name: "我的积分",
          path: '/point'
        }]
    })

    onMounted(async () => {
      const {data} = await getUserInfo()
      state.user = data
      state.loading = false
    })

    const goBack = () => {
      router.go(-1)
    }

    const goTo = (r, query) => {
      router.push({path: r, query: query || {}})
    }

    return {
      ...toRefs(state),
      goBack,
      goTo
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';

.user-box {
  .user-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    border-bottom: 1px solid #dcdcdc;

    .user-name {
      font-size: 14px;
    }
  }

  .user-info {
    width: 94%;
    margin: 10px;
    height: 135px;
    background: linear-gradient(90deg, @primary, #51c7c7);
    box-shadow: 0 2px 5px #269090;
    border-radius: 6px;

    .info {
      position: relative;
      display: flex;
      width: 100%;
      height: 100%;
      padding: 25px 20px;
      .boxSizing();

      img {
        .wh(60px, 60px);
        border-radius: 50%;
        margin-top: 4px;
      }

      .user-desc {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        line-height: 20px;
        font-size: 14px;
        color: #fff;

        span {
          color: #fff;
          font-size: 14px;
          padding: 2px 0;
        }
      }

      .account-setting {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 13px;
        color: #fff;

        .van-icon-setting-o {
          font-size: 16px;
          vertical-align: -3px;
          margin-right: 4px;
        }
      }
    }
  }

  .user-list {
    padding: 0 20px;
    margin-top: 20px;
    padding-bottom: 100px;

    li {
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;

      .van-icon-arrow {
        margin-top: 13px;
      }
    }
  }
}
</style>
